import { switchMap } from 'rxjs';
import { fromFetch } from 'rxjs/fetch';
import { userDeleteFavorite } from 'constants/routes';

function deleteUserFavorite(id) {
  const url = `${userDeleteFavorite}?id=${id}`;

  return fromFetch(url, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
    },
  }).pipe(switchMap((response) => response.json()));
}

export default deleteUserFavorite;
